export default __webpack_public_path__ + "static/media/agrisamplefinal.a4b5c6af.png";